import { normalizeExportFilters } from '../../../utils/exportFilters';
import { VISIT_TABS_INDEX } from '../../../redux/slices/visitsSlice';
import { resolverIdsEstado } from './estadosPorTab';
import { formatStartOfDay, formatEndOfDay, formatDate } from './visitasDateFilters';

/**
 * Body de POST /visitas/exportar con los mismos filtros que la grilla.
 *
 * El estado elegido llega como `estado` (en extraFilters, o en filters cuando
 * viene de una tarjeta del Home). La grilla lo convierte en `idsEstado`; acá se
 * hace lo mismo y no se manda `estado` suelto, porque el backend no lo conoce.
 */
export const armarFiltrosExportacion = (
    tab: VISIT_TABS_INDEX,
    filters: Record<string, any> = {},
    extraFilters: Record<string, any> = {}
) => {
    const { estado, ...normalizados } = normalizeExportFilters(filters, extraFilters, {
        fechaVisita: formatDate,
        fechaInicio: formatStartOfDay,
        fechaFin: formatEndOfDay
    });

    return { ...normalizados, idsEstado: resolverIdsEstado(tab, estado) };
};
